<template>
    <div class="flex items-center space-x-4 text-sm">
        <button 
            @click="$emit('filter-change', 'all')"
            :class="[
                'hover:text-foxy-action transition-colors',
                currentFilter === 'all' ? 'text-foxy-action font-semibold' : 'text-foxy-text-secondary'
            ]"
        >
            Всі ({{ totalCount }})
        </button>
        <button 
            @click="$emit('filter-change', 'unread')"
            :class="[
                'hover:text-foxy-action transition-colors',
                currentFilter === 'unread' ? 'text-foxy-action font-semibold' : 'text-foxy-text-secondary'
            ]"
        >
            Непрочитані ({{ unreadCount }})
        </button>
        <button 
            @click="$emit('filter-change', 'replies')"
            :class="[
                'hover:text-foxy-action transition-colors',
                currentFilter === 'replies' ? 'text-foxy-action font-semibold' : 'text-foxy-text-secondary'
            ]"
        >
            Відповіді
        </button>
        <button 
            @click="$emit('filter-change', 'likes')"
            :class="[
                'hover:text-foxy-action transition-colors',
                currentFilter === 'likes' ? 'text-foxy-action font-semibold' : 'text-foxy-text-secondary'
            ]"
        >
            Лайки
        </button>
    </div>
</template>

<script>
export default {
    name: 'NotificationFilters',
    props: {
        currentFilter: {
            type: String,
            required: true
        },
        totalCount: {
            type: Number,
            required: true
        },
        unreadCount: {
            type: Number,
            required: true
        }
    },
    emits: ['filter-change']
};
</script>
